(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Timezone', Timezone);

    /* @ngInject */
    function Timezone($resource) {
        var resourceUrl = 'api/system/timezones/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    }
})();
